// extracted by mini-css-extract-plugin
export var attachment = "_l9-a";
export var emailContainer = "_l9-4";
export var emailContentPaddedContainer = "_l9-b";
export var emailHeader = "_l9-6";
export var emailIframe = "_l9-3";
export var emailInfoIcon = "_l9-9";
export var emailShortenedSummary = "_l9-e";
export var infoDropdown = "_l9-0";
export var infoRowBoundedContent = "_l9-d";
export var internal = "_l9-5";
export var merchant = "_l9-8";
export var messageInputContainer = "_l9-h";
export var normal = "_l9-7";
export var replyCard = "_l9-f";
export var subtleButton = "_l9-1";
export var subtleButtonIconContainer = "_l9-2";
export var toggleViewRepliesButton = "_l9-c";
export var wrappingText = "_l9-g";